'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgValidateCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 2a5.99 5.99 0 00-6 6c0 3.321 2.679 6 6 6s6-2.679 6-6-2.679-6-6-6zm-.507 7.987a.928.928 0 01-1.248-.006L5.102 8.879a.68.68 0 01.001-1.004l-.047.044a.765.765 0 011.048.022l.753.75 3.016-2.767a.802.802 0 011.071-.003l-.047-.044a.665.665 0 01-.01.99l-3.394 3.12z", fill: "currentColor" }))));
}

module.exports = SvgValidateCircle;
//# sourceMappingURL=ValidateCircle.js.map
